import './style.css';
import './visualiser.style.css';
import './overlay.style.css';

import Diagram from './Diagram';
import diagramData from './data';



import React from 'react';
import ReactDOM from 'react-dom';

const visNode = document.getElementById('visualiser__wrapper');

if (visNode) {
  const Visualiser = Diagram(diagramData);

  ReactDOM.render(
    <Visualiser />,
    visNode
  );
}

if(window.__DEV__) {
  module.hot.accept();
}
